<template>
    <div class="avatar" :class="getSize(size)">
        <img :src="img || imgResut" :alt="alt" :class="[getClasses(shadow, circular, borderRadius)]" v-if="showImage"
            @error="imageError" />
        <img v-else :src="imgResut">
    </div>
</template>

<script>

import Helpers from "../helpers";
import { IMGDEFOULT } from "../constans";
import { ref } from "vue";
export default {
    name: "SoftAvatar",
    props: {
        img: {
            type: String,
            required: true,
        },
        alt: {
            type: String,
            default: "",
        },
        size: {
            type: String,
            default: null,
        },
        shadow: {
            type: String,
            default: null,
        },
        borderRadius: {
            type: String,
            default: null,
        },
        circular: Boolean,
    },

    setup() {
        const imgResut = ref("")
        const showImage = ref(true);

        // const imageLoaded = () => {
        // };

        const imageError = () => {
            imgResut.value = IMGDEFOULT

            showImage.value = false;
        };

        const getSize = (size) => (size ? `avatar-${size}` : null)
        const getClasses = (shadow, circular, borderRadius) => {
            let shadowValue, circularValue, borderRadiusValue;

            if (shadow) {
                shadowValue = shadow === "regular" ? "shadow" : `shadow-${shadow}`;
            } else {
                shadowValue = null;
            }

            circularValue = circular ? "rounded-circle" : null;

            borderRadiusValue = borderRadius ? `border-radius-${borderRadius}` : null;

            return `${shadowValue} ${circularValue} ${borderRadiusValue}`;
        }



        const validateImg = async (img) => {
            await Helpers.checkImageExists(img)
                .then((exists) => {
                    if (exists === true) {
                        return IMGDEFOULT

                    } else {
                        return IMGDEFOULT

                    }
                }
                ).catch(() => {
                    console.log(imgResut)
                });
        }




        return {
            validateImg,
            getSize,
            getClasses,
            imgResut,
            showImage,
            imageError
        }
    }
};
</script>
